export default __webpack_public_path__ + "static/media/158.cf2c548d.jpg";